import React from "react"
import { SectionTitle, DataTable, PaginationControls, StatusBadge } from "../components"
import { cardStyle, loadingStyle } from "../styles/commonStyles"
import { formatThaiBuddhistDate } from "../../../libs/dateUtils"
import { getPaginationInfo } from "../utils/helpers"

const EmailLogsTab = ({ data: emailLogs, loading, currentPage, totalPages, totalCount, perPage, fetchData, id }) => {
	const { indexOfFirstItem } = getPaginationInfo(currentPage, perPage, totalCount)

	const handlePageChange = (page) => {
		fetchData(id, page)
	}

	const headers = ["#", "วันที่สร้าง", "รหัสติดตาม", "ผู้รับ", "ประเภท", "สถานะ"]

	const rows = (emailLogs || []).map((log, index) => [
		`${indexOfFirstItem + index}.`,
		formatThaiBuddhistDate(log.createdAt),
		log.trackingId,
		log.to,
		log.type,
		<StatusBadge key="status" status={log.status} />,
	])

	return (
		<div className="card-style" style={cardStyle}>
			<SectionTitle title="ประวัติการส่งอีเมล" />

			{loading && (
				<div
					style={{
						...loadingStyle,
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						background: "rgba(255,255,255,0.8)",
						zIndex: 10,
					}}
				>
					กำลังโหลด...
				</div>
			)}

			<div style={{ position: "relative", opacity: loading ? 0.6 : 1 }}>
				<DataTable headers={headers} rows={rows} emptyMessage="ไม่พบข้อมูลการส่งอีเมล" />

				{totalPages > 1 && (
					<PaginationControls
						currentPage={currentPage}
						totalPages={totalPages}
						totalCount={totalCount}
						perPage={perPage}
						isLoading={loading}
						onPageChange={handlePageChange}
					/>
				)}
			</div>
		</div>
	)
}

export default EmailLogsTab
